import React from "react";

const AddPrescription = () => {
  return <div></div>;
};

export default AddPrescription;
